'use strict';

var _main = require('./src/lib/main.js');

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _main2.default; /* eslint-disable import/no-commonjs */



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/docsearch.js/dist/npm/index.js
// module id = ../../node_modules/docsearch.js/dist/npm/index.js
// module chunks = 6